import { apiFetch } from "@/utils";


// Récupération des données de monitoring
function importData() {
  return apiFetch("mme/import-data" );
}

function getStatus() {
  return apiFetch("mme/status");
}

function getForms() {
  return apiFetch("mme/forms");
}

function getLeads(lastStateOnly = false) {
  return apiFetch("mme/leads?lastStateOnly=" + lastStateOnly);
}

function updateEstimateState(stateId, leadId, statusId, comment, date = "") {
  return apiFetch("mme/update-lead?StateId=" + stateId + "&LeadId=" + leadId + "&StatusId=" + statusId + "&Comment=" + comment + "&Date=" + date);
}

function readLead(leadId) {
  return apiFetch("mme/read-lead?LeadId=" + leadId);
}

export default {
  importData,
  getStatus,
  getForms,
  getLeads,
  updateEstimateState,
  readLead
}
export {
  importData,
  getStatus,
  getForms,
  getLeads,
  updateEstimateState,
  readLead
}



// WEBPACK FOOTER //
// ./src/utils/mme.js